import { z } from 'zod';

export const queuePoolSchema = z.object({
  inFlight: z.number(),
  limit: z.number(),
});

export type IQueuePool = z.infer<typeof queuePoolSchema>;
